import React, {Component} from 'react';
import codeten from "assets/img/code10.png";

class DocumentationFour extends Component {
    render() {
        return (
            <div>
                            <div>
                                <div className="p-20">
                                    <br />
                                    <p>Simulate payment terminal (EDC) actions on the portal</p>
                                    <br/>
                                    <div className="clearfix"></div>
                                    <img src={codeten} alt={codeten} className="mSpaceLogo" width={'98%'}/>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <div className="clearfix"></div>
                                    <blockquote>
                                        <small>Simulator (left) - It will fetch latest invoices as per the configuration set for merchant, and simulates payment flow.</small>
                                        <small>Logs (right) - Shows simulator action logs and integration server request responses. </small>
                                    </blockquote>
                                </div>
                            </div>

                        </div>
        );
    }
}

export default DocumentationFour;